import { IAutoMapper } from "../../../../core/automapper/interfaces";

export const mapAuditPackage = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "AuditPackage")
    .forMember("auditPackageID", o => o.AuditPackageID || o.auditPackageID || 0)
    .forMember("projectID", o => o.ProjectID || o.projectID || 0)
    .forMember("chaseID", o => o.ChaseID || o.chaseID)
    .forMember("memberID", o => o.MemberID || o.memberID)
    .forMember("numeratorID", o => o.NumeratorID || o.numeratorID)
    .forMember("auditReady", o => o.AuditReady || o.auditReady || "")
    .forMember("status", o => o.Status || o.status || "")
    .forMember("modifyUserID", o => o.ModifyUserID || o.modifyUserID || 0)
    .forMember("modifyDate", o => {
      const dateValue = o.ModifyDate || o.modifyDate;
      return dateValue ? new Date(dateValue) : new Date();
    });
};
